import React, { Component } from 'react'
import { APP_URL_API } from '../../setup/configs'
import SearchBox from '../common/SearchBox'
import axios from 'axios'

class SelectCongregation extends Component {
    constructor(props) {
        super(props)

        this.state = {
          searchString: '',
          congregations: {}
        }

        this.onHandleChange = this.onHandleChange.bind(this);
        this.onHandleAdd = this.onHandleAdd.bind(this);

        this.CancelToken = axios.CancelToken;
        this.source = this.CancelToken.source();
    };
    onHandleChange(event) {
        this.setState({searchString: event.target.value});
    }
    onHandleAdd(congregation) {
        this.setState({
            searchString: ''
        }, this.props.onHandleAttachCongregation(congregation))
    }
    componentWillUnmount() {
         this.source.cancel('Fetching congregations canceled by the user.');
    }
    componentDidMount() {
        const token = sessionStorage.getItem('id_token');
        const config = { 'Authorization': 'Bearer '+ token};
        const url = APP_URL_API + 'organizations/type/congregation';

        this.serverRequest =
            axios
                .get(url, {headers: config, cancelToken: this.source.token})
                .then(function(response) {
                    this.setState({
                        congregations: response.data.data,
                        dataFetched: true
                    })
                }.bind(this))
                .catch(function(thrown) {
                    if(axios.isCancel(thrown)) {
                        // console.log('Request canceled', thrown.message);
                    } else {
                        // handle error
                    }
                })
    }
    render() {
        if(this.state.dataFetched) {
            return(
                <div>
                    <SearchBox placeholder="Søg og tilføj menigheder" onChange={this.onHandleChange} value={this.state.searchString} />
                    {this.state.dataFetched && <SearchResult searchString={this.state.searchString} onHandleAdd={this.onHandleAdd} congregations={this.state.congregations} />}
                </div>
            )
        } else {
            return <div>Indlæser...</div>
        }
    }
}

class SearchResult extends Component {
    render() {
        const searchresult = [];
        this.props.congregations.forEach(function(congregation, index) {
            if(this.props.searchString.length >= 3 && congregation.name.toLowerCase().indexOf(this.props.searchString.toLowerCase()) >= 0) {
                searchresult.push(<Option congregation={congregation} key={index} onHandleAdd={this.props.onHandleAdd} />);
            }
        }.bind(this));
        if(searchresult.length > 0) {
            return(
                <div>
                    <ul className="selectOrganization__list">{searchresult}</ul>
                </div>
            )
        } else {
            return null;
        }
    }
}

const Option = (props) => {
    return (
        <li className="selectOrganization__item" onClick={() => props.onHandleAdd(props.congregation)}>{props.congregation.name}</li>
    )
}

export default SelectCongregation;


// WEBPACK FOOTER //
// ./src/modules/congregations/SelectCongregation.js